import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import PlayIcon from '@material-ui/icons/PlayCircleFilled';

import { StyledDialog, StyledLink } from './VideoInstructionsStyles';
import './VideoInstructionsTranslate';

const videoInstructions = [
  {
    ru: '/server/folder/media/MAIN_JETYSU_RU.mp4',
    kk: '/server/folder/media/MAIN_JETYSU_KK.mp4',
    ru_name: 'Основной ролик получения государственных услуг в сфере образования на портале e-zhetysu.kz!',
    kk_name: 'Порталда білім беру саласындағы мемлекеттік қызметтерді алудың негізгі ролигі e-zhetysu.kz!'
  },
  {
    ru: '/server/folder/media/ACCEPT_DOC_EDU_RU_PEP.mp4',
    kk: '/server/folder/media/ACCEPT_DOC_EDU_KK_PEP.mp4',
    ru_name: 'Прием документов и зачисление в организации образования (начальные, осн. ср., общ.ср, спец.)',
    kk_name: 'Білім беру ұйымдарына құжаттарды қабылдау және оқуға қабылдау (мектепке дейінгі, бастауыш, негізгі орта, жалпы орта, арнайы)'
  },
  {
    ru: '/server/folder/media/SURVEY_RU.mp4',
    kk: '/server/folder/media/SURVEY_KK.mp4',
    ru_name: 'Инструкция по прохождению анкетирования для выбора до 4-х дошкольных организаций',
    kk_name: '4 мектепке дейінгі ұйымды таңдау үшін сауалнамадан өту жөніндегі нұсқаулық'
  },
  {
    ru: '/server/folder/media/INSTRUCTIONS_DDO_RU.mp4',
    kk: '/server/folder/media/INSTRUCTIONS_DDO_RU.mp4',
    ru_name: 'Инструкция по постановке на очередь, получению направления и подаче документов в дошкольные организации',
    kk_name: 'Инструкция по постановке на очередь, получению направления и подаче документов в дошкольные организации'
  }
];

function VideoInstructions() {
  const { t, i18n } = useTranslation();
  const [selected, setSelected] = useState(null);

  return (
    <div className="mb3 mt3 fullWidth">
      <Typography
        children={t('videoInstructions_title')}
        color="secondary"
        variant="h6"
      />
      <div className="mb3"/>
      {videoInstructions.map(
        (item, key) =>
          <Card
            key={key}
            className="my1 p2 pointer flex items-center"
            variant="outlined"
            onClick={() => setSelected(item)}
          >
            <PlayIcon color="action" className="mr2"/>
            <StyledLink>{item[`${i18n.language}_name`]}</StyledLink>
          </Card>
      )}
      {selected && (
        <StyledDialog open={true} onClose={() => setSelected(null)} maxWidth="lg">
          <div className="p2 bold">{selected[`${i18n.language}_name`]}</div>
          <video key={i18n.language} width="100%" controls="controls">
            <source
              src={selected[i18n.language]}
              type="video/mp4"
            />
          </video>
        </StyledDialog>
      )}
    </div>
  );
}

export default VideoInstructions;
